import {getOut, getToken} from "../Utils/Common";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
//import {getToken} from "../Utils/Common";

export async function uploadLVS3API(filename, file) {

    let url = `${process.env.REACT_APP_BACKEND_API_URI}project/getpresignedurl`
	//let url = "http://0.0.0.0:60/projects/getpresignedurl"
	let f = JSON.stringify({
        "token":getToken(),
        "filename":filename
	})

	let uploadURL = await fetch(url, {
		method: "POST",
		 headers: {
		 	//'Authorization': getToken(),
		 	"Content-Type": "application/json"
		 },
		body: f
	}).then(data => data.json())

    // if (uploadURL.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
	// 		getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
	// 	}

	//upload file on s3
	// let responseUploadProcess = await fetch(uploadURL.body, {
	// 	method: "PUT",
	// 	headers: {
	// 		"Access-Control-Allow-Origin": "*",
	// 		"Access-Control-Allow-Headers": "Content-Type",
	// 		"Access-Control-Allow-Methods": "OPTIONS,POST,GET",
	// 	},
	// 	body: file
	// })

	/*if (responseUploadProcess.status === 200) {
		responseUploadProcess.S3URL = uploadURL.body
		console.log("The LV File is uploaded to S3 bucket.",responseUploadProcess)
	}*/



	////////////////////
    const client = new S3Client({
      region: 'eu-central-1',
      credentials: {
        accessKeyId:"AKIATV2WZPLTDDOSMKMJ",
        secretAccessKey: "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",
      },
    });

    const params = {
      Bucket: 'lvs-reports-files-bucket',
      Key: uploadURL.body,
      Body: file,
    };
    const putObject = new PutObjectCommand(params);
    let responseUploadProcess = await client.send(putObject);
    responseUploadProcess = responseUploadProcess.$metadata
    if (responseUploadProcess.httpStatusCode === 200) {
		responseUploadProcess.S3URL = uploadURL.body
		console.log("The LV File is uploaded to S3 bucket.",responseUploadProcess)
	}
	///////////////////
	return responseUploadProcess
}

//import {PutObjectCommand, S3Client} from "@aws-sdk/client-s3";

export async function uploadLVS3APIFORMOBILEAPP(projectID, filename, file) {

    let url = `${process.env.REACT_APP_BACKEND_API_URI}project/getpresignedurlformobileapp`
    let f = JSON.stringify({
        "filename": filename,
        "projectID": projectID,
        "token":getToken()
    })


    let uploadURL = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: f
    }).then(data => data.json())


    if (uploadURL.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
			getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
		}

    const client = new S3Client({
        region: 'eu-central-1',
        credentials: {
            accessKeyId: "AKIATV2WZPLTDDOSMKMJ",
            secretAccessKey: "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",
        },
    });

    const params = {
        Bucket: 'lvs-reports-files-bucket',
        Key: uploadURL.body,
        Body: file,
    };
    const putObject = new PutObjectCommand(params);
    let responseUploadProcess = await client.send(putObject);
    responseUploadProcess = responseUploadProcess.$metadata
    if (responseUploadProcess.httpStatusCode === 200) {
        responseUploadProcess.S3URL = uploadURL.body
        console.log("The LV File is uploaded to S3 bucket.", responseUploadProcess)
    }

    return responseUploadProcess
}

